import IslandPage from './IslandPage';

export default IslandPage;
